import { Link } from 'react-router';
import { useShop } from '../app/boot.tsx';
import { StaffTabs, useShopPaths } from '../app/nav.tsx';
import { Banner, Page } from '../ui/index.tsx';

const SECTIONS: { title: string; items: [string, string][] }[] = [
  { title: 'ร้านและช่าง', items: [['/staff/manage/barbers', 'ช่าง'], ['/staff/manage/services', 'บริการและราคา'], ['/staff/manage/hours', 'เวลาทำงาน'],
    ['/staff/manage/time-off', 'วันหยุด / ลา'], ['/staff/manage/special-hours', 'เวลาทำงานพิเศษ']] },
  { title: 'การตั้งค่า', items: [['/staff/manage/settings', 'กติกาการจองและการแจ้งเตือน'], ['/staff/manage/shop-info', 'ข้อมูลร้าน'],
    ['/staff/manage/staff', 'พนักงานและลิงก์เชิญ'], ['/staff/manage/group', 'กลุ่ม LINE แจ้งเตือนพนักงาน'], ['/staff/manage/rich-menu', 'รูปเมนู LINE']] },
  { title: 'รายงาน', items: [['/staff/manage/reports', 'รายงานยอดจอง'], ['/staff/manage/export', 'ส่งออก Excel']] },
];

export function Manage() {
  const { shop, me, isOwner } = useShop();
  const { href } = useShopPaths();
  return (
    <>
      <Page title="จัดการร้าน">
        {me.shop.status === 'overdue' && <Banner kind="warn">กรุณาชำระค่าบริการ SalonFlow เพื่อใช้งานต่อเนื่อง</Banner>}
        {me.shop.status === 'suspended' && <Banner kind="error">ระบบถูกระงับ กรุณาติดต่อ SalonFlow</Banner>}
        {!shop.bookingOpen && me.shop.status !== 'suspended' && (
          <Banner kind="info" action={{ label: 'เปิดรับจอง', href: href('/staff/manage/settings') }}>ยังไม่เปิดรับจองออนไลน์</Banner>
        )}
        {SECTIONS.map((s) => (
          <section key={s.title}>
            <p className="section-title">{s.title}</p>
            <div className="menu-list">
              {s.items.map(([path, label]) => <Link key={path} to={href(path)}><span>{label}</span><span aria-hidden="true">›</span></Link>)}
            </div>
          </section>
        ))}
        <p className="section-title">โหมดลูกค้า</p>
        <div className="menu-list"><Link to={href('/book')}><span>ดูหน้าจองแบบลูกค้า</span><span aria-hidden="true">›</span></Link></div>
      </Page>
      <StaffTabs owner={isOwner} />
    </>
  );
}
